<template>
    <div id="ManagePlaceMarker">
            <l-marker v-show="true"
                      ref="place"
                      :lat-lng="position"
                      :icon="icon"
                      :draggable="true"
                      @click="ManagePlace"
            />

        <b-container fluid class="footer text-center" v-if="placeOn">
            <b-button class="m-1" @click.stop.prevent="ManagePlace()">{{this.$t('GO_ON')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="cancel()">{{this.$t('CANCEL')}}</b-button>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>
        <b-container fluid class="footer text-center" v-else>
            <span class="pulse m-1">{{ this.$t('CLICK_MAP') }}</span>
            <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
        </b-container>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>

</template>

<script>
import { BContainer, BButton } from 'bootstrap-vue';
//import L from 'leaflet';
import { latLng  /*, icon */} from "leaflet";
import { LMarker } from "vue2-leaflet";
import { L } from "./LIconPulse.js";
import Help from "./Help.vue";
require('@/assets/css/LIconPulse.css');

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "ManagePlaceMarker",
  components: {
    LMarker, Help,
    BContainer, BButton
  },
  props: {
    map: Object
  },
  data: function() {
    return {
      zoom: 18,
      center: latLng(0, 0),
      options: {},
      position: latLng(0, 0),
      placeOn: false,
      userName: '',
      placeName: '',
      placeType: '',
      lng: 0.0,
      lat: 0.0,
      icon: null,
      act: '',
      helpName: 'HelpManagePlaceMarker1',
      showHelp: false
    }
  },
  metaInfo() {
    return {
        title: 'itsmap.ru'
    }
  },
  mounted() {
    let vm = this;
    this.map.on('click', function(e) {
        vm.addMarker(e);
    });
    this.options.dragging = true;
    this.userName = this.$store.state.curUserName;
    if(!this.userName) this.$showErr(this.$t('TMOUT'), 401);
    this.placeName = this.$rmEncHyp(this.$route.params.itemName);
    if(this.placeName!='_') this.getPlaceMarker();
    else this.act = this.getUserPos();
  },
  methods: {
    async getUserPos() {
        this.lat = this.$store.state.curPos.lat;
        this.lng = this.$store.state.curPos.lng;
        this.zoom = this.$store.state.curPos.zoom;
        this.center = latLng(this.lat, this.lng);
        this.sendPosToMap();
    },
    async getPlaceMarker() {
        try {
            const response = await this.$http.get('/getPlaceMarker', {
                params: {
                    placeName: this.placeName,
                    userName: this.userName
                }
            });
            let markInfo = response.data;
            this.curLat = this.lat = markInfo.markLat;
            this.curLng = this.lng = markInfo.markLng;
            this.zoom = this.curZoom = markInfo.markZoom;
            this.placeType = markInfo.markType;
            this.center = latLng(this.lat, this.lng);
            this.position = this.center;
            this.placeOn = true;
            this.icon = L.icon.pulse({iconSize:[20,20],color:'red'})
            this.sendPosToMap();
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('ManagePlaceMarker: getPlaceMarker() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    sendPosToMap() {
            //this.$store.commit('setCurPos', {lat: this.lat, lng: this.lng, zoom: this.zoom } )
            //this.$emit('setPos');
            this.map.setView(this.center, this.zoom);
    },
    addMarker(e) {
         this.position = e.latlng;
         this.placeOn = true;
         this.helpName = 'HelpManagePlaceMarker2';
         this.icon = L.icon.pulse({iconSize:[20,20],color:'red'})
         //this.options.dragging = false;
    },
    removeMarker(index) {
      this.markers.splice(index, 1);
    },
    cancel() {
        this.$router.go(-1);
    },
    ManagePlace() {
        this.lat = this.$refs['place'].mapObject.getLatLng().lat;
        this.lng = this.$refs['place'].mapObject.getLatLng().lng;
        this.zoom = this.map.getZoom();
        this.$router.push({
            path: '/ManagePlace/'+this.$addEncHyp(this.placeName),
            query: {
                curLat: this.lat,
                curLng: this.lng,
                curZoom: this.zoom,
            }
        })
    }
  }
};
</script>

<style scoped>
  @keyframes header{
    0% { color: #fff;}
    50% { color: #2ca1bb;}
  }
  .pulse{
    transform: translate(-50%, -50%);
    z-index: 10;
    animation: header 4s infinite;
  }
</style>